module.exports = __webpack_public_path__ + "static/img/dialogback.a40e3cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/dialogback.png
// module id = RIoH
// module chunks = 5